import { ALLOCATIONS_ROLES, INSIGHTS_ROLES, ALLOCATION_REPORT_ROLES, UNDERWRITING_DEPARTMENTS, UNDERWRITING_AGENTS, DEALER_DIRECT_QUEUE_DEPARTMENTS } from "@/constants/appRoles";
import { LucideIcon, BarChart, Table, Users, ShieldCheck, ListChecks, Search, SearchCheck } from "lucide-react";

export interface SidebarItem {
  title: string;
  url: string;
  icon: LucideIcon;
  requiredRoles?: readonly string[];
  requiredDepartments?: readonly string[];
  requiredAgentIds?: readonly number[];
}

export const sidebarItems: SidebarItem[] = [
  // {
  //   title: "Home",
  //   url: "/",
  //   icon: Home,
  // },
  // {
  //   title: "Search",
  //   url: "/search",
  //   icon: Search,
  // },
  {
    title: "Pipeline",
    url: "/pipeline",
    icon: Table,
  },
  {
    title: "Allocations",
    url: "/allocations",
    icon: Users,
    requiredRoles: ALLOCATIONS_ROLES,
  },
  {
    title: "Allocation Report",
    url: "/allocation-report",
    icon: SearchCheck,
    requiredRoles: ALLOCATION_REPORT_ROLES,
  },
  {
    title: "Dealer Search",
    url: "/dealer-search",
    icon: Search,
  },
  {
    title: "Insights & Reports",
    url: "/insights-reports",
    icon: BarChart,
    requiredRoles: INSIGHTS_ROLES,
  },
  {
    title: "Underwriting Queue",
    url: "/underwriting-queue",
    icon: ShieldCheck,
    requiredDepartments: UNDERWRITING_DEPARTMENTS,
    requiredAgentIds: UNDERWRITING_AGENTS,
  },
  {
    title: "Dealer Direct Prop Queue",
    url: "/dealer-direct-prop-queue",
    icon: ListChecks,
    requiredDepartments: DEALER_DIRECT_QUEUE_DEPARTMENTS,
    // requiredAgentIds: UNDERWRITING_AGENTS,
  },
];
